import { motion } from "framer-motion";

export const Cursor = ({ mousePosition, isHovered }) => (
  <motion.div
    className={`custom-cursor ${isHovered ? 'hovered' : ''}`}
    animate={{ x: mousePosition.x, y: mousePosition.y }}
    transition={{ type: "spring", stiffness: 500, damping: 28, mass: 0.5 }}
  />
);